const storeManageChilds = [
  // 门店管理
  {
    path: "madministra",
    name: "Madministra",
    component: () => import("@/views/storeManage/madministra.vue"),
    children: [
      {
        path: "administra",
        name: "Administra",
        component: () => import("@/views/storeManage/children/administra.vue"),
      },
    ],
  },
  {
    path: "mclassification",
    name: "Mclassification",
    component: () => import("@/views/storeManage/mclassification.vue"),
    children: [
      {
        path: "classification",
        name: "Classification",
        component: () => import("@/views/storeManage/children/classification.vue"),
      },
    ],
  },
  // 就餐记录
  {
    path: "dinings",
    name: "Dinings",
    component: () => import("@/views/storeManage/dinings.vue"),
    children: [
      {
        path: "diningRecords",
        name: "DiningRecords",
        component: () => import("@/views/storeManage/children/diningRecords.vue"),
      },
    ],
  },
  // 乘车记录
  {
    path: "byCar",
    name: "ByCar",
    component: () => import("@/views/storeManage/byCar.vue"),
    children: [
      {
        path: "travelRecord",
        name: "TravelRecord",
        component: () => import("@/views/storeManage/children/travelRecord.vue"),
      },
    ],
  },
  // 会员管理
  {
    path: "doorManage",
    name: "DoorManage",
    component: () => import("@/views/storeManage/doorManage.vue"),
    children: [
      {
        path: "doorMember",
        name: "DoorMember",
        component: () => import("@/views/storeManage/children/doorMember.vue"),
      },
      // 积分抵扣
      {
        path: "doorpointsDeduc",
        name: "DoorpointsDeduc",
        component: () => import("@/views/storeManage/children/doorpointsDeduc.vue"),
      },
      // 积分结算
      {
        path: "doorpointsSettle",
        name: "DoorpointsSettle",
        component: () => import("@/views/storeManage/children/doorpointsSettle.vue"),
      },
    ]
  },
];
export default storeManageChilds;
